import React from "react";
import {
  StyledContentNavBar,
  ContentNavBarItem,
  ContentNavBarDivider,
  ContentNavBarItemDisabled,
} from "./styled";

export function ContentNavBar({
  items,
}: {
  items: {
    name: string;
    to: string;
    disabled?: boolean;
  }[];
}) {
  return (
    <>
      <StyledContentNavBar>
        {items.map((item, index) => (
          <>
            {!item.disabled && (
              <ContentNavBarItem to={item.to} exact>
                {item.name}
              </ContentNavBarItem>
            )}
            {item.disabled && (
              <ContentNavBarItemDisabled>{item.name}</ContentNavBarItemDisabled>
            )}
            {items.length - 1 !== index && <ContentNavBarDivider />}
          </>
        ))}
      </StyledContentNavBar>
    </>
  );
}
